var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Closing Agent"}},[_c('contact-selector',{attrs:{"name_prefix":"closing_agent","available_contacts":_vm.available_contacts,"contact_type":"closing_agent","value":{
            contact_id: _vm.closing.contact_id,
            name: _vm.closing.closing_agent_name,
            email: _vm.closing.closing_agent_email,
            phone: _vm.closing.closing_agent_contract_number,
        },"phone_label":"Contact #","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }